import useHttp from './use-http';

const useStoryInsights = () => {
    const postActivationInsights = (briefId, taskId, payload) => {
        const url = `/api/v1/activation-briefs/${briefId}/tasks/${taskId}/story-insights`;

        const { http } = useHttp();
        return http.post(url, payload);
    };

    const postCampaignInsights = (proposalId, jobId, payload) => {
        const url = `/api/v1/proposals/${proposalId}/jobs/${jobId}/story-insights`;

        const { http } = useHttp();
        return http.post(url, payload);
    };

    return {
        postActivationInsights,
        postCampaignInsights
    };
};

export default useStoryInsights;
